import React, { useEffect, useState } from 'react';
import Logo from './Assets/rotating-logo.png';
import { BrowserRouter as Router, Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import Login from './Web Pages/Authentication/Login';
import 'bootstrap/dist/css/bootstrap.min.css';
import Verify from './Web Pages/Authentication/Verify';
import ModuleSelector1 from './Web Pages/Authentication/ModuleSelector1';
import AccountingDashboard from './Web Pages/Accoungting/AccountingDashboard';
import Remitance from './Web Pages/Accounting/Remitance/Remitance.js';
import LoanAccount from './Web Pages/Accounting/Loan Account/LoanAccount.js';
import ManageCurrrency from './Web Pages/Budget/Accounting/ManageCurrency/ManageCurrency.js';
import ProvinceStatus from './Web Pages/Budget/Accounting/ProvinceStatus/ProvinceStatus.js';
import Customers from './Web Pages/Budget/Accounting/ProvinceRecords/Customers/Customers.js';
import Suppliers from './Web Pages/Budget/Accounting/ProvinceRecords/Suppliers/Suppliers.js';
import UserProvince from './Web Pages/Budget/Accounting/UserProvince/UserProvince.js';
import Region from './Web Pages/Budget/Accounting/ManageRegion/Region/Region.js';
import User from './Web Pages/Budget/Accounting/ManageUser/User/User.js';
import Province from './Web Pages/Budget/Accounting/UserProvince/Province/Province.js';
import ManageRegion from './Web Pages/Budget/Accounting/ManageRegion/ManageRegion.js';
import ProvinceRecords from './Web Pages/Budget/Accounting/ProvinceRecords/ProvinceRecords.js';
import AccountApprovals from './Web Pages/Budget/Accounting/AccountApprovals/AccountApprovals.js';
import ManageUser from './Web Pages/Budget/Accounting/ManageUser/ManageUser.js';
import AuditUser from './Web Pages/Budget/Accounting/AuditUser/AuditUser.js';
import ChartAccount from './Web Pages/Budget/Chart of Account/ChartofAccount/ChartAccount.js';
import AssignnUser from './Web Pages/Budget/Accounting/AssignnUser/AssignnUser.js';
import Customer from './Web Pages/Accounting/Customer/Customer.js';
import 'react-loading-skeleton/dist/skeleton.css'
import ReportPage from './Web Pages/Accounting/Report/ReportPage.js';
import SuppliersAccount from './Web Pages/Accounting/Manage Suppliers Payables/Suppliers.js';
import Cashbook from './Web Pages/Accounting/Report/Cashbook.js';
import PrintCashbook from './Web Pages/Accounting/Print/PrintCashbook.js';
import MonthlyRemitance from './Web Pages/Accounting/MonthlyRemitance/MonthlyRemitance.js';
// import NewPayment from './Web Pages/Accounting/Payments/NewPayment.js';
import NewPaymentPage from './Web Pages/Accounting/Payments/NewPaymentPage.js';
import LoanBeneficiary from './Web Pages/Accounting/LoanBeneficiary/LoanBeneficiary.js';
import PurchaseInvoices from './Web Pages/Accounting/PurchaseInvoice/PurchaseInvoices.js';
import SupplierPersonal from './Web Pages/Accounting/Sales Invoice/SupplierPersonalLedgers.js';
import SchedulePayable from './Web Pages/Accounting/Schedule of Payables/SchedulePayable.js';
import StaffLoan from './Web Pages/Accounting/StaffLoan/StaffLoan.js';
import RepaymentSchedule from './Web Pages/Accounting/Repayment Schedule/RepaymentSchedule.js';
import CustomerLedger from './Web Pages/Accounting/Customer/CustomerLedger.js';
import NewPayablesPage from './Web Pages/Accounting/Payments/NewPayablesPage.js';
import Instruction from './Web Pages/Accounting/Payments/Instruction/Instruction.js';
import StaffLedger from './Web Pages/Accounting/StaffLedger/StaffLedger.js';
import CashReceipt from './Web Pages/Receipt/CashReceipt.js';
import PrintCashReceipt from './Web Pages/Accounting/Print/PrintCashReceipt.js';
import ReceiptRemitance from './Web Pages/Receipt/ReceiptRemitance.js';
import SuppliersLedger from './Web Pages/Accounting/SuppliersLedger/SuppliersLedger.js';
import Payee from './Web Pages/Accounting/SuppliersLedger/Payee.js';
import HmoPage from './Web Pages/Accounting/SuppliersLedger/Hmo.js';
import Pension from './Web Pages/Accounting/SuppliersLedger/Pension.js';
import UploadRemittanceModal from './Web Pages/Accounting/MonthlyRemitance/UploaRemitance.js';
import PrintCustomerLedger from './Web Pages/Accounting/CustomerLedger/PrintCustomerLedger.js';
import SuppliersPersonalLedger from './Web Pages/Accounting/SuppliersLedger/SuppliersPersonalLedger.js';
import CustomerPersonalLedger from './Web Pages/Accounting/CustomerLedger/CustomerPersonalLedger.js';
import LoanLedger from './Web Pages/Accounting/Loan Ledger/LoanLedger.js';
import PrintActivity from './Web Pages/Accounting/Print/PrintActivity.js';
import Paye from './Web Pages/Accounting/SuppliersLedger/Paye.js';
import Contractors from './Web Pages/Accounting/SuppliersLedger/Contractors.js';
import LoanDisbursement from './Web Pages/Accounting/Payments/LoanDisbursement.js';
import TrialBalance from './Web Pages/Accounting/Trial Balance/TrialBalance.js';
import ApprovedPayables from './Web Pages/Accounting/Payments/ApprovedPayables.js';
import PayablesPayment from './Web Pages/Accounting/Payments/PayablesPayment.js';
import JournalEntries from './Web Pages/Accounting/Payments/JournalEntries.js';
import PayablesEntries from './Web Pages/Accounting/Payments/PayablesEntries.js';
import ChartofAccount from './Web Pages/Accounting/ChartofAccount/ChartofAccount.js';
import IncomeStatement from './Web Pages/Accounting/Print/IncomeStatement.js';
import PrintOutstanding from './Web Pages/Accounting/Print/PrintOutstanding.js';
import LoanReceivables from './Web Pages/Accounting/PrintLoan/PrintLoans.js';
import PrintRemit from './Web Pages/Accounting/PrintLoan/PrintRemit.js';
import BankLodgement from './Web Pages/Receipt/BankLodgement.js';
import MakeJournal from './Web Pages/Accounting/Payments/MakeJournal.js';
import LodgedTransactions from './Web Pages/Receipt/LodgedTransactions.js';
import IncomeStatementDetailed from './Web Pages/Accounting/Print/IncomeStatementDetailed.js';
import FinancialPosition from './Web Pages/Accounting/Print Finanical Position/FinancialSummary.js';
import FinancialPositionDetailed from './Web Pages/Accounting/Print Finanical Position/FinancialSummaryDetailed.js';
import BankSummary from './Web Pages/Accounting/PrintBank/PrintBank.js';
import ScheduleofPayables from './Web Pages/Accounting/ScheduleofPayables/ScheduleofPayables.js';
import PrintRecievables from './Web Pages/Accounting/PrintAgeReport/PrintAgeReceivables.js';
import PrintPayables from './Web Pages/Accounting/PrintAgeReport/PrintPayables.js';
import JournalSearch from './Web Pages/Accounting/SearchJournal/JournalSearch.js';
import UploadBalance from './Web Pages/Accounting/Upload Journal/UploadBalance.js';
import BulkEntries from './Web Pages/Accounting/Upload Journal/UploadBalanceBulk.js';
import UploadEntry from './Web Pages/Accounting/Upload Journal/UploadEntry.js';
import PendingApproval from './Web Pages/Accounting/Approval/PendingAccount.js';
import DisapproveAccount from './Web Pages/Accounting/Approval/DIsapprovedAccount.js';
import SalesReport from './Web Pages/Accounting/Report/SalesReport.js';
import PurchaseReport from './Web Pages/Accounting/Report/PurchaseReport.js';
import CashReceiptss from './Web Pages/Accounting/Payments/CashManagement.js';
import CashMovement from './Web Pages/Accounting/Cash Movement/CashMovement.js';
import SalaryPayable from './Web Pages/Accounting/Payments/SalaryPayable.js';
import PrintCashReceipts from './Web Pages/Accounting/Print/PrintCashReceipts.js';
import ChequePay from './Web Pages/Accounting/Payments/ChequePayment.js';
import BankTransfer from './Web Pages/Accounting/Payments/BankTransfer.js';
import NewCheque from './Web Pages/Accounting/Payments/NewCheque.js';
import ReconciliationDashboard from './Web Pages/Reconciliation/ReconciliationDashboard.js';
import BankReconciliationNew from './Web Pages/Reconciliation/BankReconciliationNew.js';
import ReconciliationReport from './Web Pages/Accounting/Report/ReconciliationReport.js';
import ReconSummaryReport from './Web Pages/Accounting/Report/ReconSummaryReport.js';
import CashMovements from './Web Pages/Receipt/CashMovement/CashMovements.js';
import PaymentsUpload from './Web Pages/Accounting/Payments/PaymentsUpload.js';
import BudgetDashboard from './Web Pages/Budget/Budget Dashboard/BudgetDashboard.js';
import AccountCategory from './Web Pages/Budget/Account Category/AccountCategory.js';
import ChartofaCcount from './Web Pages/Budget/Chart of Account/ChartofAccount.js';
import ChartLedger from './Web Pages/Budget/ChartLedger/ChartLedger.js';
import FinanceStatement from './Web Pages/Budget/Financial Statements/FinanceStatement.js';
import PrntCashbook from './Web Pages/Budget/Print/PrintCashbook.js';
import CurrencyRate from './Web Pages/Admin/CurrencyRate/CurrencyRate.js';
import AdminDashboard from './Web Pages/Admin/Admin Dashboard/AdminDashboard';

import TaxRate from './Web Pages/Admin/Manage Tax/TaxRate.js';
import ManageContinent from './Web Pages/Admin/Manage Continent/ManageContinent.js';
import ManageRegions from './Web Pages/Admin/Manage Region/ManageRegion.js';
import ManageUsers from './Web Pages/Admin/ManageUser/ManageUsers.js';
import BudgetTrialBalance from './Web Pages/Accounting/Trial Balance/TrialBalance.js';
import BudgetIncomeStatement from './Web Pages/Budget/Print/IncomeStatement.js';
import BudgetIncomeStatementDetailed from './Web Pages/Budget/Print/IncomeStatementDetailed.js';
import BudgetPrintActivity from './Web Pages/Budget/Print/PrintActivity.js';
import AssignUser from './Web Pages/Admin/Assign User/AssignUser.js';
import ChangeWorkingMonth from './Web Pages/Admin/ChangeWorkingMonth/ChangeWorkingMonth.js';
import BudgetFinancialPosition from './Web Pages/Budget/Print Finanical Position/FinancialSummary.js';
import BudgetFinancialPositionDetailed from './Web Pages/Budget/Print Finanical Position/FinancialSummaryDetailed.js';
import BudgetBankSummary from './Web Pages/Budget/PrintBank/PrintBank.js';
import PendingAccount from './Web Pages/Admin/Pending Account/PendingAccount.js';
import DisapprovedAccount from './Web Pages/Budget/Account Disapprove/DisapprovedAccount.js';
import ReceiptManagement from './Web Pages/Admin/ReceiptManagement/ReceiptManagement.js';
import ResetMonth from './Web Pages/Budget/Reverse Working Month/ResetMonth.js';
import ViewLoan from './Web Pages/Budget/Accounting/ProvinceRecords/Loans/LoanAccount.js';
import ExpenseAccount from './Web Pages/Admin/ExpenseAccount/ExpenseAccount.js';
import LodgedTransaction from './Web Pages/Admin/LodgedTransaction/LodgedTransaction.js';
import Budget from './Web Pages/Admin/Budget/Budget.js';
import Payroll from './Web Pages/Admin/Payroll/Payroll.js';
import PrintCashReceiptssss from './Web Pages/Admin/ReceiptManagement/PrintCashReceiptssss.js';
import AccountCategory2 from './Web Pages/Budget/Account Category/AccountCategory2.js';
import AccountCategory3 from './Web Pages/Budget/Account Category/AccountCategory3.js';
import AccountCategory4 from './Web Pages/Budget/Account Category/AccountCategory4.js';
import AccountCategory5 from './Web Pages/Budget/Account Category/AccountCategory5.js';
import AccountCategory6 from './Web Pages/Budget/Account Category/AccountCategory6.js';
import Disapproved from './Web Pages/Budget/Accounting/AccountApprovals/Disapproved.js';
import Approved from './Web Pages/Budget/Accounting/AccountApprovals/Approved.js';
import ChangeApproval from './Web Pages/Admin/ChangeWorkingMonthApproval/ChangeApprovals.js';
import ChangeDisapprove from './Web Pages/Admin/ChangeWorkingMonthDisapprove/ChangeDisapprove.js';
import ChangePending from './Web Pages/Admin/ChangeWorkingMonthPending/ChangePending.js';
import ReconSummaryReportAcct from './Web Pages/Budget/ReconSummaryReport/ReconSummaryReportAcct.js';
import OutstandingReport from './Web Pages/Budget/OutstandingReport/OutstandingReport.js';
// import ManageCurrencyRate from './Web Pages/Budget/Accounting/Manage Currency Rate/ManageCurrency.js';

import ManageParish from './Web Pages/FixedAssetReport/Fixed Asset Report/ManageParish.js';
import FixedReport from './Web Pages/FixedAssetReport/Report/ReportPage.js';
import ComplianceReport from './Web Pages/FixedAssetReport/Report/ComplianceReport.js';
import FixedAssetReport from './Web Pages/FixedAssetReport/Report/FixedReport.js.js';
import FixedUser from './Web Pages/FixedAssetReport/ManageUser/ProvincalUser.js';
import FixedAssetArea from './Web Pages/FixedAssetReport/Fixed Asset Report/FixedArea.js';
import ManageZones from './Web Pages/Manage Zones/ManageZones.js';
// import ForgotPassword from './Web Pages/Authentication/ForgotPassword.js';
// import ResetPassword from './Web Pages/Authentication/ResetPassword.js';
// import PayableInstruction from './Web Pages/Accounting/SuppliersLedger/PayableInstruction.js';
// import PayableCheque from './Web Pages/Accounting/PayableCheque.js';
import ParishReport from './Web Pages/FixedAssetReport/Fixed Asset Report/ParishReport.js';
import ViewFixedAsset from './Web Pages/FixedAssetReport/Fixed Asset Report/ViewFixedAsset.js';
import ViewAsset from './Web Pages/FixedAssetReport/Fixed Asset Report/ViewAssets.js';
import PrintFixedReport from './Web Pages/FixedAssetReport/Report/PrintFixedReport.js';
import AdminParish from './Web Pages/FixedAssetReport/Fixed Asset Report/AdminParish.js';
import AdminRegion from './Web Pages/FixedAssetReport/AdminRegion/AdminRegion.js';
import FixedAssetAdminUser from './Web Pages/FixedAssetReport/Config/FixedAssetAdminUser.js';
import FixedAssetContinent from './Web Pages/FixedAssetReport/Config/FixedContinent.js';
// import FixedAssetAdminParish from './Web Pages/FixedAssetReport/Config/AdminReport.js';
import ReportAdmin from './Web Pages/FixedAssetReport/Config/AdminReport.js';
import AdminViewAsset from './Web Pages/FixedAssetReport/Fixed Asset Report/AdminViewAsset.js';
import Tax from './Web Pages/Accounting/Loan Account/Tax.js';
// import AdminProvince from './Web Pages/FixedAssetReport/AdminProvince/FixedProvince.js';

function App() {
  const [loading, setLoading] = useState(true);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
    const timer = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(timer);
          setLoading(false);
          return 100;
        }
        return prev + 10;
      });
    }, 100);

    return () => clearInterval(timer);
  }, []);

  const LoadingScreen = () => (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "#fff",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      {/* Rotating + pulsing logo */}
      <img
        src={Logo}
        alt="Loading..."
        style={{
          width: "150px",
          height: "auto",
          marginBottom: "20px",
          animation: "spinPulse 2s infinite linear",
        }}
      />

      {/* Progress bar */}
      <div
        style={{
          width: "200px",
          height: "4px",
          backgroundColor: "#e0e0e0",
          borderRadius: "2px",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: `${progress}%`,
            height: "100%",
            background: '#174384',
            transition: "width 0.3s ease",
          }}
        ></div>
      </div>

      {/* Percentage text */}
      <div
        style={{
          marginTop: "10px",
          color: "#555",
          fontSize: "14px",
        }}
      >
        {progress}%
      </div>

      {/* Inline keyframes */}
      <style>
        {`
        @keyframes spinPulse {
          0%   { transform: rotate(0deg) scale(1); }
          50%  { transform: rotate(180deg) scale(1.1); }
          100% { transform: rotate(360deg) scale(1); }
        }
      `}
      </style>
    </div>
  );


  if (loading) {
    return <LoadingScreen />;
  }
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route path='/accounting/supplier' element={<SuppliersAccount />} />
      <Route path='/accounting/cash_receipt' element={<CashReceipt />} />
      <Route path='/accounting/loan_ledger' element={<LoanLedger />} />
      <Route path='/accounting/receipt_remitance' element={<ReceiptRemitance />} />
      <Route path='/accounting/print_cash_receipt' element={<PrintCashReceipt />} />
      <Route path='/accounting/print_outstanding_remittances' element={<PrintOutstanding />} />
      <Route path='/accounting/print_activity_report_acct' element={<PrintActivity />} />
      <Route path='/accounting/purchase_invoices' element={<PurchaseInvoices />} />
      <Route path='/accounting/suppliers_ledger' element={<SuppliersLedger />} />
      <Route path='/accounting/customers_ledger' element={<CustomerLedger />} />
      <Route path='/accounting/suppliers_personal_ledgers' element={<SuppliersPersonalLedger />} />
      <Route path='/accounting/payable_entries' element={<PayablesEntries />} />
      <Route path='/accounting/salary_payables_entries' element={<SalaryPayable />} />
      <Route path='/accounting/print_personal_ledgers' element={<CustomerPersonalLedger />} />
      <Route path='/accounting/print_income_statement' element={<IncomeStatement />} />
      <Route path='/accounting/print_income_statement_detailed' element={<IncomeStatementDetailed />} />
      <Route path='/accounting/paye' element={<Payee />} />
      <Route path='/accounting/hmo' element={<HmoPage />} />
      <Route path='/accounting/pension' element={<Pension />} />
      <Route path='/accounting/paye_invoices' element={<Paye />} />
      <Route path='/accounting/contractor_invoices' element={<Contractors />} />
      <Route path='/accounting/suppliers_personal_ledger' element={<SupplierPersonal />} />
      {/* <Route path='/accounting/schedule_of_payable' element={<SchedulePayable/>}/> */}
      <Route path='/account_payables_bulk' element={<NewPayablesPage />} />
      <Route path='/account_payables_payment' element={<PayablesPayment />} />
      <Route path='/account_approved_payables' element={<ApprovedPayables />} />
      <Route path='/print_instructn' element={<Instruction />} />
      <Route path='/account_payments' element={<NewPaymentPage />} />
      <Route path='/account_payments_upload' element={<PaymentsUpload />} />
      <Route path='/accounting/view_journal_entries' element={<JournalEntries />} />
      <Route path='/accounting/new_journal_entries' element={<MakeJournal />} />
      <Route path='/account_loan_disbursement' element={<LoanDisbursement />} />
      <Route path='/admin/operations/account' element={<AccountApprovals />} />
      <Route path='/admin/operations/approved_account' element={<Approved />} />
      <Route path='/admin/operations/disapproved_account' element={<Disapproved />} />


      {/* <Route path='/accounting/schedule_of_payable' element={<SchedulePayables/>}/> */}
      <Route path='/accounting/report' element={<ReportPage />} />


      <Route path="/otp_secure" element={<Verify />} />
      <Route path="/welcome" element={<ModuleSelector1 />} />
      <Route path="/accounting" element={<AccountingDashboard />} />
      <Route path="/admin/loan_account" element={<LoanAccount />} />
      <Route path="/admin/province" element={<UserProvince />} />
      <Route path="/admin/continent" element={<ManageCurrrency />} />
      <Route path="/admin/complianceProvince" element={<AssignnUser />} />
      <Route path="/admin/auditProvince" element={<AuditUser/>} />
      <Route path="/admin/region" element={<ManageRegion />} />
      <Route path="/admin/manage_user" element={<ManageUser />} />
      <Route path="/accounting/customers" element={<Customer />} />
      <Route path="/accounting/remitances" element={<Remitance />} />
      <Route path="/accounting/cashbook" element={<Cashbook />} />
      <Route path="/accounting/print_cashbook" element={<PrintCashbook />} />
      <Route path="/admin/customers" element={<Customers />} />
      <Route path="/admin/suppliers" element={<Suppliers />} />

      <Route path="/accounting/upload_remitance_excel" element={<UploadRemittanceModal />} />
      <Route path="/reconciliation_report" element={<ReconciliationReport />} />
      <Route path="/reconciliation/summary_report" element={<ReconSummaryReport />} />
      <Route path="/accounting/display_remitance_excel" element={<MonthlyRemitance />} />
      {/* <Route path="/accounting/upload_remitance_excel" element={<MonthlyRemitance/>} /> */}
      <Route path="/accounting/loan" element={<LoanBeneficiary />} />
      <Route path="/accounting/receivables/staff_loan" element={<StaffLoan />} />
      <Route path="/accounting/receivables/repayment_schedule" element={<RepaymentSchedule />} />

      <Route path="/accounting/print_customer_ledger" element={<PrintCustomerLedger />} />
      <Route path="/accounting/staff_personal_ledger" element={<StaffLedger />} />
      <Route path="/accounting/charts_of_account/account" element={<ChartofAccount />} />
      <Route path="/budget/charts_of_account/account" element={<ChartAccount />} />
      <Route path="/budget/charts_of_account/Province" element={<Province/>} />
      <Route path="/budget/charts_of_account/Region" element={<Region/>} />
      <Route path="/budget/charts_of_account/User" element={<User/>} />

      <Route path="/accounting/cash_movement" element={<CashMovement />} />
      <Route path="/reconciliation" element={<ReconciliationDashboard />} />
      <Route path="/accounting/bank_reconciliationnew" element={<BankReconciliationNew />} />


      <Route path="/print_payments" element={<NewCheque />} />
      <Route path="/payment_instructions" element={<BankTransfer />} />
      <Route path="/cheque_payments" element={<ChequePay />} />
      <Route path="/accounting/purchase_report" element={<PurchaseReport />} />
      <Route path="/accounting/sales_report" element={<SalesReport />} />
      <Route path="/accounting/account_dispproved" element={<DisapproveAccount />} />
      <Route path="/accounting/account_approvals" element={<PendingApproval />} />
      <Route path="/accounting/upload_journal_entry" element={<UploadEntry />} />
      <Route path="accounting/upload_opening_balance_bulk" element={<BulkEntries />} />
      <Route path="/accounting/upload_opening_balance" element={<UploadBalance />} />
      <Route path="/accounting/search_account_journals" element={<JournalSearch />} />
      <Route path="/accounting/aged_analysis_payables" element={<PrintPayables />} />
      <Route path="/accounting/aged_analysis_receivables" element={<PrintRecievables />} />
      <Route path="/accounting/bank_report" element={<BankSummary />} />
      <Route path="/accounting/statement_of_financial_position" element={<FinancialPositionDetailed />} />
      <Route path="/financial_position" element={<FinancialPosition />} />
      <Route path="/accounting/trial_balance" element={<TrialBalance />} />
      <Route path="/accounting/print_loan_receivables" element={<LoanReceivables />} />
      <Route path="/accounting/print_outstanding_remittance" element={<PrintRemit />} />
      <Route path="/cash_management/bank_lodgement/pending" element={<BankLodgement />} />
      <Route path="/cash_management/lodged_transactions" element={<LodgedTransactions />} />
      <Route path="/accounting/schedule_of_payable" element={<ScheduleofPayables />} />
      <Route path="/cash_receipt" element={<CashReceiptss />} />
      <Route path="/print_cash_receipts" element={<PrintCashReceipts />} />
      <Route path="/accounting_cashmovement" element={<CashMovements />} />


      <Route path="/admin" element={<BudgetDashboard />} />
      <Route path="/admin/Tax" element={<Tax />} />
      <Route path="/budget/view_loan" element={<ViewLoan />} />
      {/* <Route path="/admin" element={<BudgetDashboard />} /> */}
      <Route path="/budget/account_category" element={<AccountCategory />} />
      <Route path="/budget/charts_of_accounts_view_class" element={<AccountCategory2 />} />
      <Route path="/budget/charts_of_accounts_view_category" element={<AccountCategory3 />} />
      <Route path="/budget/charts_of_accounts_view_subcategory" element={<AccountCategory4 />} />
      <Route path="/budget/charts_of_accounts_view_sub_subcategory" element={<AccountCategory5 />} />
      <Route path="/budget/charts_of_accounts_view_sub_sub_subcategory" element={<AccountCategory6 />} />
      <Route path="/budget/chart_of_account" element={<ChartofaCcount />} />
      <Route path="/budget/chart-ledger" element={<ChartLedger />} />
      <Route path="/budget/finance-statement" element={<FinanceStatement />} />
      <Route path="/admin/ProvinceRecords" element={<ProvinceRecords />} />
      <Route path="/budget/print_cashbook" element={<PrntCashbook />} />
      <Route path="/provincestatus_reports" element={<ProvinceStatus/>} />
      <Route path="/budget/trial_balance" element={<BudgetTrialBalance />} />
      <Route path="/budget/income_statement" element={<BudgetIncomeStatement />} />
      <Route path="/budget/income_statement-detailed" element={<BudgetIncomeStatementDetailed />} />
      <Route path="/budget/print_activity" element={<BudgetPrintActivity />} />
      <Route path="/budget/financial_summary" element={<BudgetFinancialPosition />} />
      <Route path="/budget/financial_summary_detailed" element={<BudgetFinancialPositionDetailed />} />
      <Route path="/budget/bank_report" element={<BudgetBankSummary />} />

      <Route path="/admin/exchange_rate" element={<CurrencyRate />} />
      <Route path="/admin/users" element={<ManageUsers />} />
      <Route path="/admin/tax" element={<TaxRate />} />
      <Route path="/admin/continent" element={<ManageContinent />} />
      {/* <Route path="/admin/region" element={<ManageRegions />} /> */}
      <Route path="/admin/assigned_users" element={<AssignUser />} />
      {/* <Route path="/admin/manage_currency" element={<ManageCurrencyRate />} /> */}
      <Route path="/admin/change_working_month_approvals" element={<ChangeWorkingMonth />} />


         <Route path="/accounting/reset_working_month" element={<ResetMonth/>} />
         {/* <Route path="/admin/exchange_rate" element={<CurrencyRate/>} /> */}
         {/* <Route path="/admin/users" element={<ManageUsers/>} /> */}
         {/* <Route path="/admin/tax" element={<TaxRate/>} /> */}
         {/* <Route path="/admin/continent" element={<ManageContinent/>} /> */}
         {/* <Route path="/admin" element={<AdminDashboard/>} /> */}
         <Route path="/admin/users" element={<ManageUsers/>} />
         <Route path="/admin/tax" element={<TaxRate/>} />
         <Route path="/admin/continent" element={<ManageContinent/>} />
         {/* <Route path="/admin/region" element={<ManageRegions/>} />
         <Route path="/admin/province" element={<AdminProvince/>} /> */}
         {/* <Route path="/admin/region" element={<ManageRegions/>} /> */}
          <Route path="/admin/accountant_province" element={<AssignUser/>} />
           <Route path="/admin/change_working_month" element={<ChangeWorkingMonth/>} /> 
           <Route path="/admin/change_working_month_approval" element={<ChangeApproval/>} /> 
           <Route path="/admin/change_working_month_disapprove" element={<ChangeDisapprove/>} /> 
           <Route path="/admin/change_working_month_pending" element={<ChangePending/>} /> 
           <Route path="/admin/cash_management" element={<ReceiptManagement/>} /> 
           <Route path="/budgets/account_approvals" element={<PendingAccount/>} /> 
           <Route path="/budgets/account_dispproved" element={<DisapprovedAccount/>} /> 
           <Route path="/admin/expenses" element={<ExpenseAccount/>} /> 
           <Route path="/admin/lodged_transactions" element={<LodgedTransaction/>} /> 
           <Route path="/admin/budget" element={<Budget/>} /> 
           <Route path="/admin/payroll" element={<Payroll/>} /> 
           <Route path="/print_cash_receiptss" element={<PrintCashReceiptssss />} /> 
           <Route path="/admin/summary_report" element={<ReconSummaryReportAcct />} /> 
           <Route path="/admin/bank_reconciliationnew" element={<OutstandingReport />} /> 

           <Route path='/fixed_admin_asset_report' element={<ReportAdmin />} />
          <Route path='/fixed_asset_continent' element={<FixedAssetContinent />} />
        <Route path='/fixed_asset/admin_user' element={<FixedAssetAdminUser />} />
          <Route path="/fixed_asset_home" element={<ManageParish />} />
          <Route path="/fixed/asset/report" element={<FixedReport />} />
          <Route path="/fixed_asset_report" element={<FixedAssetReport />} />
          <Route path="/fixed_asset/print_report" element={<PrintFixedReport />} />
          <Route path="/fixed_compliance_report" element={<ComplianceReport />} />
          <Route path="/fixed_asset/provincial_user" element={<FixedUser />} />
          <Route path="/fixed_asset/area" element={<FixedAssetArea />} />
          <Route path="/fixed_asset/zone" element={<ManageZones />} />
          <Route path="/fixed_asset/parish" element={<ParishReport />} />
          <Route path="/fixed_assets_registers" element={<ViewFixedAsset />} />
          <Route path="/view_asset" element={<ViewAsset />} />
          <Route path="/view_asset_report" element={<AdminViewAsset/>} />
          <Route path="/fixed_asset_admin_home" element={<AdminParish />} />
          <Route path="/fixed_asset_region" element={<AdminRegion />} />
           
    </Routes>
  );
}

export default App;
